import Routes from "./routes";
import AuthApi from "./modules/authApi";
import SeriesApi from "./modules/seriesApi";
import UserApi from "./modules/userApi";

const baseUrl = process.env.VUE_APP_SERVER_URL;

export const userApi = new UserApi(baseUrl, Routes.USERS);
export const authApi = new AuthApi(baseUrl, Routes.AUTH);
export const seriesApi = new SeriesApi(baseUrl, Routes.OMDB);
